export default "__VITE_ASSET__w8fAjgbi__"